import { DataGridActiveColumns } from '@virtus/components/DataGrid/models';

export const ExceptionDetailsActiveColumns: DataGridActiveColumns = {
  timestamp: true,
  outerMessage: true,
  innermostMessage: true,
  OuterMethod: true,
  OuterType: true,
  roleInstance: true,
};

export const ExceptionDetailsBaseColumns = {
  timestamp: {
    field: 'timestamp',
    filterPlaceholder: 'Search TimeStamp',
    width: 170,
    Filter: 'DateFilter',
  },
  outerMessage: {
    field: 'outerMessage',
    filterPlaceholder: 'Search outerMessage',
    width: 240,
  },
  innermostMessage: {
    field: 'innermostMessage',
    filterPlaceholder: 'Search InnermostMessage',
    width: 240,
  },
  OuterMethod: {
    field: 'OuterMethod',
    filterPlaceholder: 'Search OuterMethod',
    width: 240,
  },
  OuterType: {
    field: 'OuterType',
    filterPlaceholder: 'Search OuterType',
    width: 240,
  },
  roleInstance: {
    field: 'roleInstance',
    filterPlaceholder: 'Search RoleInstance',
    width: 130,
  },
};

export const ExceptionHeaders = [
  {
    caption: 'Exception Time',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'timestamp',
    dataType: 'string',
    width: '40%',
  },
  {
    caption: 'Outer Message',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'outerMessage',
    dataType: 'string',
    width: '80%',
  },
  {
    caption: 'Inner Most Message',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'innermostMessage',
    dataType: 'string',
    width: '80%',
  },
  {
    caption: 'Outer Method',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'OuterMethod',
    dataType: 'string',
    width: '80%',
  },
  {
    caption: 'Outer Type',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'OuterType',
    dataType: 'string',
    width: '80%',
  },
  {
    caption: 'Role Instance',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'roleInstance',
    dataType: 'string',
    width: '40%',
  },
];
